module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-20.7425442d.png";